import { gql, useMutation } from '@apollo/client';

const PURCHASE_ADDITIONAL_SCANS = gql`
  mutation PurchaseAdditionalScans {
    purchaseAdditionalScans {
      success
      newScanBalance
    }
  }
`;

interface PurchaseAdditionalScansData {
  purchaseAdditionalScans: {
    success: boolean;
    newScanBalance: number;
  };
}

export function usePurchaseAdditionalScansMutation() {
  return useMutation<PurchaseAdditionalScansData>(PURCHASE_ADDITIONAL_SCANS, {
    refetchQueries: ['GetUser', 'GetCompany'],
  });
}
